module.exports = __webpack_public_path__ + "static/media/elektronikai-uzem-kivitelezes.6129941e.jpg";